import { render, staticRenderFns } from "./pd-lens-guide.vue?vue&type=template&id=05fd7089&"
import script from "./pd-lens-guide.vue?vue&type=script&lang=js&"
export * from "./pd-lens-guide.vue?vue&type=script&lang=js&"
import style0 from "./pd-lens-guide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PrimaryButton: require('/opt/build/repo/storefront/components/atoms/Button/PrimaryButton.vue').default})
